import { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { translationsNamespaceContext } from '../../TranslationsNamespaceProvider/translationsNamespaceContext';
import { translationsContext } from '../translationsContext';

/**
 * Optional values to be interpolated into the translated message.
 * These values can include formatted XML elements or primitive types.
 */

/**
 * Represents the return type of formatFunction from useTranslationsFromNamespace hook.
 * @param key Translations key which is part of namespace translations
 * @param values Values to be interpolated into the translated message
 * @typeParam T The type of translations.
 */

/**
 * Represents the return type of useTranslations hook along with a formatting function.
 * @typeParam T The type of translations.
 */

/**
 * A custom hook to access translations and a formatting function.
 *
 * @typeParam T The type of translations.
 * @returns The translations and formatting function.
 */
export const useTranslationsFromNamespace = () => {
  const {
    translationsWithNamespaces,
    defaultTranslationsWithNamespaces
  } = useContext(translationsContext);
  const {
    namespace
  } = useContext(translationsNamespaceContext);
  const {
    formatMessage: f
  } = useIntl();
  return useMemo(() => {
    const formatMessage = (key, values) => f({
      id: `${namespace}:${String(key)}`
    }, values);
    return {
      translations: translationsWithNamespaces ? translationsWithNamespaces[namespace] : defaultTranslationsWithNamespaces[namespace],
      formatMessage
    };
  }, [f, namespace, translationsWithNamespaces, defaultTranslationsWithNamespaces]);
};
//# sourceMappingURL=useTranslationsFromNamespace.js.map